// Co-branded partner landing pages for the October offer. Each partner gets
// /<code>, which credits their referral code (first touch, like ?ref=) and shows
// their brand over the same offer, eligibility and checkout as /offer. The copy
// here is GPT's, from a fact sheet (Joe's rule: GPT writes customer prose).
export type PartnerBrand = {
  code: string;
  name: string;
  logo: string;      // a light logo that reads on the dark hero
  accent: string;    // the partner's brand color, for small accents and the button
  kicker: string;
  intro: string;
};

export const PARTNERS: Record<string, PartnerBrand> = {
  limelite: {
    code: 'limelite',
    name: 'Limelite Casting',
    logo: '/partners/limelite-logo.svg',   // limelitecast.com's own wordmark, white with lime green
    accent: '#08FE26',
    kicker: 'For Limelite talent',
    intro: "We've partnered with Limelite on this Hey Joe Plus offer. Keep training and auditioning between bookings with live events, classes, replays and self-tape tools.",
  },
};
